<div class="pager-container">
  <div class="pagination" *ngIf="hasRecords" style="margin: 0px 0px 0px 0px;">
    <div style="float: left; margin-right: 20px; white-space: nowrap;">
      <label style="float: left; margin-right: 4px; margin-top: 6px;">Page Size</label>
      <select [(ngModel)]="pagedResult.PaginationInfo.PageSize" (change)="changePageSize()" class="form-control" style="width: 100px; float: left;">
        <option>10</option>
        <option>25</option>
        <option>50</option>
        <option>100</option>
      </select>
    </div>
    <div style="float: left; vertical-align: top;">
      <nav class="d-inline-block" aria-label="Page navigation">
        <ul class="pagination">
          <li class="page-item" [ngClass]="{'disabled':isFirstPage}">
            <a class="page-link" [class.disabled]="isFirstPage" (click)="!isFirstPage && firstPage()">&laquo;</a>
          </li>
          <li class="page-item" [ngClass]="{'disabled':isFirstPage}">
            <a class="page-link" [class.disabled]="isFirstBlock" (click)="!isFirstBlock && prevBlock()">...</a>
          </li>
          <li class="page-item" [ngClass]="{'disabled':isFirstPage}">
            <a class="page-link" [class.disabled]="isFirstPage" (click)="!isFirstPage && prevPage()">&lt;</a>
          </li>
          <li class="page-item" *ngFor="let block of pageBlock" [ngClass]="{'active':block.isActive}">
            <a class="page-link" (click)="page(block.page)">{{block.page}}</a>
          </li>
          <li class="page-item" [ngClass]="{'disabled':isLastPage}">
            <a class="page-link" [class.disabled]="isLastPage" (click)="!isLastPage && nextPage()">&gt;</a>
          </li>
          <li class="page-item" [ngClass]="{'disabled':isLastBlock}">
            <a class="page-link" [class.disabled]="isLastBlock" (click)="!isLastBlock && nextBlock()">...</a>
          </li>
          <li class="page-item" [ngClass]="{'disabled':isLastPage}">
            <a class="page-link" [class.disabled]="isLastPage" (click)="!isLastPage && lastPage()">&raquo;</a>
          </li>
        </ul>
      </nav>
      <div *ngIf="recordsVerbiage" class="d-inline-block">
        {{recordsVerbiage}}
      </div>
    </div>
  </div>
  <div id="norecords" *ngIf="hasLoaded && !hasRecords">
    <p>No records found</p>
  </div>
</div>
